import { useDataItem } from 'scrivito'

import { BreadcrumbItem } from '@/Atomic/Atoms/BreadcrumbItem'
import { Breadcrumbs } from '@/Atomic/Molecules/Breadcrumbs'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'
import { getDataItemTitle } from '@/utils/dataClassMap'

export const DocumentsBreadcrumb: React.FC = () => {
  const { goToFolder, folderStack, goToRoot } = useDocumentContext()
  const dataItem = useDataItem()
  const title = getDataItemTitle(dataItem) || 'Root'

  if (folderStack.length <= 0) return null

  return (
    <div className="d-flex justify-content-start flex-warp document-breadcrumb">
      <Breadcrumbs>
        <BreadcrumbItem onClick={goToRoot}>{title}</BreadcrumbItem>
        {folderStack.map(({ id, name }, index) => (
          <BreadcrumbItem
            key={id}
            active={index === folderStack.length - 1}
            onClick={
              index === folderStack.length - 1
                ? undefined
                : () => goToFolder(id)
            }
          >
            {name}
          </BreadcrumbItem>
        ))}
      </Breadcrumbs>
    </div>
  )
}
